/* eslint-disable @typescript-eslint/no-explicit-any */
import { getParameterFromURL } from '../../../../../../utils/scripts';
import aes from 'crypto-js/aes';
import enc from 'crypto-js/enc-utf8';

import { IEveryDoggyAPIServices } from '../../../../../../utils/services/EveryDoggyAPIServices';
import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';
import OneLinkParametersHelper from '../../../../../../utils/services/OneLinkParametersComposer';
import { StripePurchaseDigitalProductRequest } from '../../../../../../utils/services/EveryDoggyAPITypes';
import { PaymentActionResult } from './types';
import { analyticsEventsTracker, EVENT_TRACKERS, GTMOnboardingFunnelEvent, GTMQuizFunnelEvent } from '../../../../../../utils/analytics';
import { EmptyObject } from '@reduxjs/toolkit';
import { getInternalPDFId } from '../../../../../../utils/scripts/getInternalPDFId';
import getAmplitudeDeviceId from '../../../../../../utils/scripts/amplitudeDeviceId';

export interface IStripeViewModel {
  getStripeKey: () => Promise<string>;
  initialEmail: () => string | null;
  processPaymentAction: (paymentMethodId: string, productId: number, email: string, stripeAmount: string, stripelName: string, stripe?: any) => Promise<EmptyObject>;
  processPaymentCancel: () => Promise<void>;
  processPaymentError: (error: any) => Promise<void>;
}

function ComposeStripeViewModel(
  sourceURL: string,
  stripePlanID: string,
  apiServices: IEveryDoggyAPIServices,
  errorLogger: IErrorLoggerWithUserSupport
): IStripeViewModel {
  const oneLinkParametersHelper = OneLinkParametersHelper;

  // returns Stripe key
  const getStripeKey = async () => {
    let data = await apiServices.getStripeConfig();
    if (!data) data = await apiServices.getStripeConfig();
    if (!data?.publishableKey) {
      throw new Error('Stripe config unavailable');
    }
    return data.publishableKey;
  };

  const initialEmail = () => {
    let emailInputValue = getParameterFromURL('emailValue', sourceURL);
    const emailInputValueFromUrl = getParameterFromURL('ev', sourceURL);

    if (emailInputValueFromUrl) {
      const emailInputValueRaw = aes.decrypt(emailInputValueFromUrl, '9213812384');
      emailInputValue = emailInputValueRaw.toString(enc);
    }

    return emailInputValue;
  };

  const processPaymentAction = async (paymentMethodId: string, productId: number, email: string, stripeAmount: string, stripelName: string, stripe: any) => {

    if (!paymentMethodId) {
      errorLogger.logError({
        name: 'Stripe error',
        message: 'no paymentMethodId',
      });
    }
    if (!email) {
      errorLogger.logError({
        name: 'Stripe error',
        message: 'no buyer email',
      });
    }

    const dataToSend: StripePurchaseDigitalProductRequest = {
      amplitude_device_id: getAmplitudeDeviceId(),
      email: email,
      payment_method_id: paymentMethodId,
      digital_product_offer_id: productId,
      fbclickid: oneLinkParametersHelper.getFBclickId(sourceURL),
      fbp: oneLinkParametersHelper.getFBp(sourceURL),
      source_url: sourceURL,
      internal_id: getInternalPDFId(productId),
    };

    return apiServices
      .purchaseStripeDigitalProduct(dataToSend, 'stripe', stripelName)
      .then(result => {
        if(result) {
          return {};
        };
      });
  };

  const processPaymentCancel = async () => {
    errorLogger.logMessage('stripe payment cancelled');
  };

  const processPaymentError = async (error: any) => {
    errorLogger.logError({
      name: 'Stripe error',
      message: JSON.stringify(error),
    });
  };

  return {
    getStripeKey,
    initialEmail,
    processPaymentAction,
    processPaymentCancel,
    processPaymentError,
  };
}

export default ComposeStripeViewModel;
